import { createAsyncThunk } from "@reduxjs/toolkit";
import type { LicenseNameDTO } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchLicenseNames = createAsyncThunk(
	"licenses/fetchlicenseNames",
	apiGet<LicenseNameDTO[]>(
		(authConfig) => authConfig.DATA_LAKE_API_ENDPOINTS.GET_LICENSE_NAMES(),
		[SCOPES.DATA_LAKE_READ],
	),
);
